import { render, staticRenderFns } from "./JSelectJingsaiProject.vue?vue&type=template&id=8561a5d6&scoped=true"
import script from "./JSelectJingsaiProject.vue?vue&type=script&lang=js"
export * from "./JSelectJingsaiProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8561a5d6",
  null
  
)

export default component.exports